import _ from 'lodash'
import {
  getClusterAttributes,
  convertClusterToAttributeOption,
  makeItemOptions,
  convertRawDataToRenderingData,
  getAttrTableFieldPrefixByLevel,
  getSpecAttributeFieldPrefixByLevel,
  getFinalAttributesForTransient
} from './util'
import { getOrderUniqueImages } from './modelsUtils'

export const getParsedTransientData = (setting, formData) => {
  const {
    mismatchedCluster,
    struDataAttrCluster
  } = setting

  const clusterAttributes = getClusterAttributes(struDataAttrCluster)

  const {
    subStationId,
    product = {}
  } = formData

  const {
    catItemId,
    struDataAttrClusterId,
    models = [],
    specs = [],
    attributes,
    shareMediaBetweenModels
  } = product

  const mismatchedClusterId = _.get(mismatchedCluster, 'id', null)

  if (
    (subStationId && catItemId && struDataAttrClusterId) ||
    !!mismatchedClusterId
  ) {
    let fetchedModels = models
    const hasSpecLevel = !_.isEmpty(specs)
    const specSize = _.size(specs)

    const localModels = []
    const firstSpec = {}
    const secondSpec = {}

    // 若是無選項則models一定要用空物件佔位
    if (!hasSpecLevel && _.isEmpty(fetchedModels)) {
      fetchedModels = [{}]
    }

    fetchedModels.forEach(
      model => {
        const localSpec = model.spec || {}

        if (specSize >= 1) {
          const { displayName } = model
          const selectedItemOptValue = displayName || _.get(localSpec, 'values[0]')
          const selectedItemOptActualValues = _.get(localSpec, 'values')
          const specName = localSpec.name
          // 如果找不到對應的Cluster代表為自訂的，所以必須加入到自訂欄位中
          const matchAttrCluster = _.find(clusterAttributes, { name: specName })
          if (!firstSpec.selectedOption) {
            firstSpec.selectedOption = {}
          }
          if (!matchAttrCluster) {
            firstSpec.customInput = specName
          }
          if (!firstSpec.selectedItemOptions) {
            firstSpec.selectedItemOptions = []
          }
          firstSpec.selectedOption = convertClusterToAttributeOption(matchAttrCluster || { name: specName })
          firstSpec.selectedItemOptions.push({
            displayName,
            label: selectedItemOptValue,
            value: selectedItemOptValue,
            values: selectedItemOptActualValues
          })
        }

        if (specSize === 2) {
          const items = _.get(model, 'items', [])
          if (!secondSpec.selectedItemOptions) {
            secondSpec.selectedItemOptions = []
          }
          secondSpec.selectedItemOptions = _.map(
            items,
            item => {
              const itemSpec = _.get(item, 'spec', {})
              if (!_.get(secondSpec, 'selectedOption', null)) {
                // 如果找不到對應的Cluster代表為自訂的，所以必須加入到自訂欄位中
                const itemSpecName = itemSpec.name
                const matchAttrCluster = _.find(clusterAttributes, { name: itemSpec.name })
                if (!secondSpec.selectedOption) {
                  secondSpec.selectedOption = {}
                }
                if (!matchAttrCluster) {
                  secondSpec.customInput = itemSpecName
                }
                secondSpec.selectedOption = convertClusterToAttributeOption(matchAttrCluster || { name: itemSpecName })
              }
              const selectedItemOptValue = _.get(item, 'displayName') || _.get(itemSpec, 'values[0]')
              const selectedItemOptActualValues = _.get(itemSpec, 'values')
              return {
                displayName: item.displayName,
                label: selectedItemOptValue,
                value: selectedItemOptValue,
                values: selectedItemOptActualValues
              }
            })
        }
      })

    const specArr = []
    if (!_.isEmpty(firstSpec)) {
      firstSpec.selectedItemOptions = makeItemOptions(firstSpec.selectedItemOptions)
      specArr.push(firstSpec)
    }
    if (!_.isEmpty(secondSpec)) {
      secondSpec.selectedItemOptions = makeItemOptions(secondSpec.selectedItemOptions)
      specArr.push(secondSpec)
    }

    // merge spec if they exist
    const spec = _.merge([], specs, specArr)

    fetchedModels.forEach(
      (model, modelIdx) => {
        const {
          displayName,
          images = [],
          spec,
          items
        } = model
        const returnModel = {
          spec,
          items,
          displayName,
          shareImageModel: modelIdx === 0 && !!shareMediaBetweenModels,
          images: getOrderUniqueImages(images)
        }
        !spec && delete returnModel.spec
        localModels.push(returnModel)
      })

    const activeTransientData = _.merge(
      { hasSpecLevel },
      hasSpecLevel
        ? { spec }
        : {}
    )

    let attrTableData = _.merge(
      { models: localModels },
      hasSpecLevel
        ? {
          shareMediaBetweenModels: !!shareMediaBetweenModels,
          specs
        }
        : {}
    )

    attrTableData = convertRawDataToRenderingData({
      rawProduct: attrTableData,
      data: activeTransientData,
      hasSpecLevel
    })

    _.set(activeTransientData, getAttrTableFieldPrefixByLevel(hasSpecLevel), attrTableData)
    _.set(activeTransientData, getSpecAttributeFieldPrefixByLevel(hasSpecLevel), attributes)
    _.set(activeTransientData, getSpecAttributeFieldPrefixByLevel(hasSpecLevel), getFinalAttributesForTransient(activeTransientData, struDataAttrCluster))

    return activeTransientData
  }
}
